import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {retry} from 'rxjs/operators';
import {ErrorModalComponent} from '../../errorhandler/error-modal/error-modal.component';
import {TenantService} from '../../authentication/tenant.service';
import {Tenant} from '../model/tenant.model';

@Component({
  selector: 'app-tenant-select',
  templateUrl: './tenant-select.component.html',
  styleUrls: ['./tenant-select.component.scss']
})
export class TenantSelectComponent {

  tenants: Tenant[] = [];
  loading: number;

  constructor(@Inject(MAT_DIALOG_DATA) public data: Set<string>,
              private tenantService: TenantService,
              private matDialog: MatDialog) {
    this.loading = data.size;
    data.forEach(tenantId =>
      tenantService.getTenantById(tenantId).pipe(retry(10))
        .subscribe(
          tenant => {
            this.tenants.push(tenant);
            this.loading--;
          },
          error => matDialog.open(ErrorModalComponent, {data: error})
        )
    );
  }

  getTenantLink(tenantDomain: string){
    return 'https://' + tenantDomain + '/tng';
  }
}
